// Scroll Animation Utility
export const initScrollAnimations = () => {
  // Create intersection observer for scroll animations
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
      }
    });
  }, observerOptions);

  // Function to observe elements
  const observeElements = () => {
    const animatedElements = document.querySelectorAll('.scroll-animate');
    console.log('Found scroll-animate elements:', animatedElements.length);
    animatedElements.forEach(el => {
      // Only observe if not already observed
      if (!el.hasAttribute('data-observed')) {
        observer.observe(el);
        el.setAttribute('data-observed', 'true');
      }
    });
  };

  // Initial observation
  observeElements();

  // Re-observe after delays to catch dynamically loaded content
  setTimeout(observeElements, 100);
  setTimeout(observeElements, 500);
  setTimeout(observeElements, 1000);

  // Re-observe on window resize (important for mobile orientation changes)
  const handleResize = () => {
    setTimeout(observeElements, 100);
  };
  window.addEventListener('resize', handleResize);

  // Store resize handler for cleanup
  observer._resizeHandler = handleResize;

  return observer;
};

// First load animation utility
export const initFirstLoadAnimation = () => {
  // Check if this is the first visit (no session storage)
  const hasVisited = sessionStorage.getItem('hasVisited');
  
  if (!hasVisited) {
    // Add first-load class to body
    document.body.classList.add('first-load');
    
    // Create and add logo element
    const logoContainer = document.createElement('div');
    logoContainer.className = 'opening-logo';
    logoContainer.innerHTML = '<img src="/assets/PawilonLogo.svg" alt="Pawilon Krzyżanowskiego" />';
    document.body.appendChild(logoContainer);
    
    // Mark as visited
    sessionStorage.setItem('hasVisited', 'true');
    
    // Remove first-load class and logo after animation completes
    setTimeout(() => {
      document.body.classList.remove('first-load');
      if (logoContainer.parentNode) {
        logoContainer.parentNode.removeChild(logoContainer);
      }
    }, 3000); // 3 seconds for the animation
  }
};

// Cleanup function
export const cleanupScrollAnimations = (observer) => {
  if (observer) {
    observer.disconnect();
    // Remove resize event listener if it exists
    if (observer._resizeHandler) {
      window.removeEventListener('resize', observer._resizeHandler);
    }
  }
};
